import * as ExcelJS from "exceljs";
import FileSaver from "file-saver";
import Constants from "./constants";
import orderBy from "lodash/orderBy";

export async function downloadWorkbook(workbook, filename) {
  const buffer = await workbook.xlsx.writeBuffer();
  FileSaver.saveAs(new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  }), filename.replace(/[\\/:*?"<>|]/g, "-") + ".xlsx");
}

export function squadraWorkbook(squadra, calciatori) {
  const workbook = new ExcelJS.Workbook();
  const sheet = workbook.addWorksheet("Squadra");
  sheet.columns = [{ width: 18 }, { width: 18 }, { width: 34 }, { width: 25 }, { width: 18 }];
  sheet.addRow(["Ruolo classico", "Ruoli mantra", "Calciatore", "Club", "Prezzo pagato"]);
  sheet.getRow(1).font = { bold: true };
  sheet.views = [{ state: "frozen", ySplit: 1 }];
  const rosa = Object.entries(squadra.calciatori || {}).map(([id, acquisto]) => {
    const calciatore = calciatori[id] || {};
    const ruoloClassico = (Constants.RUOLI_NEW[calciatore.ID_Ruolo] || {}).abc;
    const ruoliMantra = (calciatore.mantra_ids || []).map(id =>
      Constants.RUOLI_MANTRA[id] ? Constants.RUOLI_MANTRA[id].label : "-"
    ).join(", ");
    return { ...calciatore, id, ruoloClassico, ruoliMantra, prezzo: acquisto.p };
  });
  orderBy(rosa, ["ID_Ruolo", "prezzo", "quotazione", "calciatore"], ["asc", "desc", "desc", "asc"])
    .forEach(calciatore => sheet.addRow([
      calciatore.ruoloClassico || "-",
      calciatore.ruoliMantra || "-",
      calciatore.calciatore || `Calciatore ${calciatore.id} (non in listone)`,
      calciatore.nomeClub || "-",
      calciatore.prezzo,
    ]));
  return workbook;
}
